/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

import { DxpCapability } from 'apps/console-core/src/Constants/DxpCapabilities/defs/DxpCapability.defs';
import { getOrganisationPath } from 'apps/console-core/src/Utilities/GetOrganisationPath/GetOrganisationPath';
import { CDP_CAPABILITY_STRINGS } from './DxpCapabilityStrings.constants';
import { DXP_MENU_CDP_SECTION, DXP_MENU_SCV_SECTION } from './NavSections.constants';

/**
 * Customer data platform (CDP).
 */
export const CUSTOMER_DATA_PLATFORM: DxpCapability = {
  key: `cdp`,
  menuSections: [DXP_MENU_CDP_SECTION, DXP_MENU_SCV_SECTION],
  path: getOrganisationPath(`/cdp`),
  prefix: `cdp`,
  title: CDP_CAPABILITY_STRINGS.title,
};
